import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';
import { servicesProviderProcessingFeesDataSchema } from './ServicesProviderProcessingFeesData.js';

class ServicesProviderProcessingFees extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderProcessingFeesDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderProcessingFees.validation', `ServicesProviderProcessingFees data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.PROCESSING_FEES,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.PROCESSING_FEES, ServicesProviderProcessingFees);

export { ServicesProviderProcessingFees };
//# sourceMappingURL=ServicesProviderProcessingFees.js.map
